import { renderToStaticMarkup } from "react-dom/server";
import { getCitationFilePath } from "../../api";
import styles from "./Answer.module.css";

type HtmlParsedAnswer = {
    answerHtml: string;
    citations: string[];
    followupQuestions: string[];
};

export function parseAnswerToHtml(answer: string, onCitationClicked: (citationFilePath: string) => void): HtmlParsedAnswer {
    const citations: string[] = [];
    const followupQuestions: string[] = [];

    let parsedAnswer = answer
        .replace(/<<([^>>]+)>>/g, (_m, content) => {
            followupQuestions.push(content);
            return "";
        })
        .trim();

    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, i) => {
        if (i % 2 === 0) return part;

        const lower = part.toLowerCase();
        if (["sistema", "fuentes", "fuente", "chat"].includes(lower)) {
            return "";
        }

        const firstTime = citations.indexOf(part) === -1;
        if (firstTime) {
            citations.push(part);
            const citationIndex = citations.length;
            const path = getCitationFilePath(part);
            return renderToStaticMarkup(
                <a className={styles.supContainer} title={part} onClick={() => onCitationClicked(path)}>
                    {citationIndex}
                </a>
            );
        }
        // Repetición: no renderizamos nada
        return "";
    });

    return {
        answerHtml: fragments.join(""),
        citations,
        followupQuestions
    };
}
